module.exports = __webpack_public_path__ + "resources/message-read-573b8c8c9e96864efcc019f4aa3c7d3d.svg";